import { Typography } from '@mui/material';
import { FC } from 'react';

interface Props {
  selected: boolean;
  text: string;
  onClick?: () => void;
}

export const ButtonText: FC<Props> = ({ selected, text, onClick }) => {
  return (
    <Typography
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        fontWeight: selected ? 'bold' : 'normal',
      }}
    >
      {text}
    </Typography>
  );
};
